/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Progress_LabelInputs */

const en_iconik_publish_progress_label = /** @type {(inputs: Iconik_Publish_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing progress`)
};

const fr_iconik_publish_progress_label = /** @type {(inputs: Iconik_Publish_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression de la publication`)
};

const de_iconik_publish_progress_label = /** @type {(inputs: Iconik_Publish_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungsfortschritt`)
};

const it_iconik_publish_progress_label = /** @type {(inputs: Iconik_Publish_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressi nella pubblicazione`)
};

const ru_iconik_publish_progress_label = /** @type {(inputs: Iconik_Publish_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ход публикации`)
};

const es_iconik_publish_progress_label = /** @type {(inputs: Iconik_Publish_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso de publicación`)
};

const zh_cn2_iconik_publish_progress_label = /** @type {(inputs: Iconik_Publish_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出版进度`)
};

const ja_iconik_publish_progress_label = /** @type {(inputs: Iconik_Publish_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出版の進捗状況`)
};

const hi_iconik_publish_progress_label = /** @type {(inputs: Iconik_Publish_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशन प्रगति`)
};

const pt_pt2_iconik_publish_progress_label = /** @type {(inputs: Iconik_Publish_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso da publicação`)
};

/**
* | output |
* | --- |
* | "Publishing progress" |
*
* @param {Iconik_Publish_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_progress_label = /** @type {((inputs?: Iconik_Publish_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_progress_label(inputs)
	if (locale === "de") return de_iconik_publish_progress_label(inputs)
	if (locale === "it") return it_iconik_publish_progress_label(inputs)
	if (locale === "ru") return ru_iconik_publish_progress_label(inputs)
	if (locale === "es") return es_iconik_publish_progress_label(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_progress_label(inputs)
	if (locale === "ja") return ja_iconik_publish_progress_label(inputs)
	if (locale === "hi") return hi_iconik_publish_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_progress_label(inputs)
	return en_iconik_publish_progress_label(inputs)
});